import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
} from '@angular/material/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslatorService } from '@sc/data-access-translation';
import {
  FormStyle,
  getLocaleMonthNames,
  TranslationWidth,
} from '@angular/common';
import { capitalize } from 'lodash-es';
import { IconComponent } from '../../icon/icon.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'sc-period-picker-header',
  styleUrls: ['./period-picker-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="header">
      <button mat-icon-button class="arrow" (click)="previousClicked()">
        <sc-icon name="arrow_left"></sc-icon>
      </button>

      <span class="header-label">{{ periodLabel }}</span>

      <button mat-icon-button class="arrow" (click)="nextClicked()">
        <sc-icon name="arrow_right"></sc-icon>
      </button>
    </div>
    <br />
  `,
  imports: [MatButtonModule, IconComponent],
})
export class PeriodPickerHeaderComponent implements OnDestroy {
  private readonly _destroyed = new Subject<void>();

  public months: readonly string[];

  constructor(
    private readonly _calendar: MatCalendar<any>,
    private readonly _dateAdapter: DateAdapter<any>,
    @Inject(MAT_DATE_FORMATS) private readonly _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef,
    private readonly translator: TranslatorService
  ) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => cdr.markForCheck());

    this.translator.getCurrentLang().subscribe((newLang) => {
      this.months = getLocaleMonthNames(
        newLang,
        FormStyle.Standalone,
        TranslationWidth.Wide
      );
    });
  }

  get periodLabel(): string {
    const currentDate = new Date(this._calendar.activeDate);
    return (
      capitalize(this.months[currentDate.getMonth()]) +
      ' ' +
      currentDate.getFullYear()
    );
  }

  previousClicked() {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
      this._calendar.activeDate,
      -1
    );
  }

  nextClicked() {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
      this._calendar.activeDate,
      1
    );
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }
}
